import React from "react";
import { Box, Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import {
  BRAND_MODAL_PAPER_PROPS,
  BRAND_MODAL_TITLE_SX,
} from "../../shared/components/modalStyles";
import HelpChatbot from "./HelpChatbot";

export default function NeedAssistanceDialog(props) {
  const { open, onClose, user } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        ...BRAND_MODAL_PAPER_PROPS,
        sx: {
          ...BRAND_MODAL_PAPER_PROPS.sx,
          border: "3px solid #00336C",
        },
      }}
    >
      <DialogTitle sx={BRAND_MODAL_TITLE_SX}>Need Help?</DialogTitle>

      <DialogContent
        dividers
        sx={{
          pt: 2.5,
          backgroundColor: "#fff",
          borderBottomLeftRadius: "13px",
          borderBottomRightRadius: "13px",
        }}
      >
        <HelpChatbot user={user} onHelpLinkClick={onClose} />

        <Box
          sx={{
            mt: 2.5,
            pt: 2,
            borderTop: "1px solid rgba(0,51,108,0.08)",
          }}
        >
          <Typography sx={{ mb: 1.5, color: "#00336C", fontWeight: 800 }}>
            Need additional assistance?
          </Typography>

          <Typography sx={{ mb: 1.25, color: "#00336C" }}>
            <strong>Phone:</strong> (518) 368-4101
          </Typography>

          <Typography sx={{ color: "#00336C", mb: 1.25 }}>
            <strong>Email:</strong>{" "}
            <Box
              component="a"
              href="mailto:garrett@camoinassociates.com"
              sx={{
                display: "inline",
                color: "#00336C",
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              garrett@camoinassociates.com
            </Box>
          </Typography>

          <Typography sx={{ color: "#00336C" }}>
            <strong>Schedule a Meeting:</strong>{" "}
            <Box
              component="a"
              href="https://calendly.com/garrett-pemeetings/prospectengage-question-troubleshooting"
              target="_blank"
              rel="noreferrer"
              sx={{
                display: "inline",
                color: "#00336C",
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              Book a Meeting
            </Box>
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
